import { render, staticRenderFns } from "./productpricing-add-or-update.vue?vue&type=template&id=4bb430a8&"
import script from "./productpricing-add-or-update.vue?vue&type=script&lang=js&"
export * from "./productpricing-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports